// import { TRENDING } from "../constants";

export const filtersState = {
    offset: 0,
    // sortBy: TRENDING,
    searchString: "",
    pageType: [],
    goalRange: { min: 0, max: 1000 },
    occasions: [],
    campaigns: [],
    countries: [],
    selectedFiltersCount: 0
}